import { Link } from "react-router-dom";
import "../styles/css/admin-style.css";
import "../styles/css/error.css";

const NotFoundPage = () => {
    return (
        <body id="page-top" className="error">

        <div className="errorLogo">
            <img src="/logo/logo.svg" alt="Barreca Logo" className="logo"/>
        </div>

        <div className="errorDiv">
            <div>
                <h2>Oops!</h2>
            </div>
            <div>
                <p>
                    Lucas ipsum dolor sit amet moff skywalker ponda calamari amidala moff luke anakin tatooine antilles.
                    Amidala skywalker calrissian gonk lars chewbacca.
                </p>
            </div>
            <div>
                <button type="button" className="btn-error btn-lg btn-block error-btn">BUTTON</button>
            </div>
        </div>


        </body>
    );
};

export default NotFoundPage;
